import {BUDGET_TYPE, QUANTITY_LOCKED_REASON} from '../../../../constants';
import {convertPriceToInvoiceCurrency, addQuantityDecimals} from './invoicing_generate_lines_utils';

// Fixed Fee Deliverable invoicing is scoped to Time & Materials projects only (per the "Deliverables
// with Different Billing Structures" PRD's V1 scope) — a Deliverable's price field isn't itself
// restricted by project budgetType, so this must be checked explicitly rather than assumed.
export const isFixedPriceDeliverableInvoiceable = (deliverable, project) =>
	project.budgetType === BUDGET_TYPE.TIME_AND_MATERIALS &&
	deliverable.price != null &&
	deliverable.invoicedAmount !== deliverable.price;

export const buildLineForFixedPriceDeliverable = (deliverable, project, invoice, company) => {
	const projectCurrency = project.rateCard ? project.rateCard.currency : company.currency;

	return {
		description: deliverable.name,
		quantity: addQuantityDecimals(1, company),
		unitPrice: convertPriceToInvoiceCurrency(deliverable.price, projectCurrency, company, invoice),
		projectId: project.id,
		deliverableIds: [deliverable.id],
		tax: invoice.tax,
		discount: invoice.discount,
		quantityLockedReason: QUANTITY_LOCKED_REASON.FIXED_PRICE_DELIVERABLE,
	};
};
